import { WcsBadgeBZone, WcsPromotion } from '@/scripts/interfaces/normalizer'

export interface WcsPlpProduct {
  badgeBZone: WcsBadgeBZone
  colors: Array<Colors>
  isDiscounted: boolean
  isPolarized: boolean
  isRemixable: boolean
  modelName: string
  offerPrice: string
  pdpUrl: string
  polarized: string
  remixable?: WcsPlpProductRemixable
}

export interface Colors {
  catentryId: string
  isCollectionSustainable: boolean
  isDiscounted: boolean
  isLimitedEdition: boolean
  isNew: boolean
  isPolarized: boolean
  isPreorder: boolean
  isPreRelease: boolean
  moco: string
  modelCode: string
  modelName: string
  offerPrice: string
  onSale: OnSale
  partNumber: string
  pdpUrl: string
  priceArray: Array<WcsPromotion>
  productImage: string
  productImageHover: string
  productType: ProductTypeE
  webExclusive: boolean
  productImageHoverView?: string
}

interface WcsPlpProductRemixable {
  label: string
  url: string
}

type OnSale = 'PRIVATE' | 'SEMIPRIVATE' | 'FALSE' | '' | null

export enum ProductTypeE {
  CASE = 'CASE',
  CLIPON = 'CLIPON',
  ELECTRONICS = 'Electronics',
  GIFT_CARDS = 'gift-cards',
  KIT = 'KIT',
  OPTICAL = 'OPTICAL',
  ROX_INSURANCE = 'ROX_INSURANCE',
  ROX_LENS = 'ROX_LENS',
  ROX_SERVICE = 'ROX_SERVICE',
  SUN = 'SUN',
}
